module.exports = function init_media_kit_archive() {

  const archive_root = document.querySelector('.media-kit-archive-main');
  if (!archive_root) return;

  const search_input = archive_root.querySelector('#search-input');
  const search_button = archive_root.querySelector('#search-assets');

  // clear any search box input in case the user browsed backwards
  clear_search_box();

  // check if the page has loaded with a category selection
  // and pre-select the category
  const q_params = new URLSearchParams(window.location.search);
  if (q_params.get('cat')) {
    const q_cat = q_params.get('cat');
    show_children('select-' + q_cat);
    select_category('select-' + q_cat);
  }

  // listen for category selections
  const category_buttons = archive_root.querySelector('.category-buttons');
  if (category_buttons) {
    category_buttons.addEventListener('click', function(e) {
      const button = e.target.closest('button');
      if (!button) return;
      show_children(button.id);
      select_category(button.id);
    });
  }

  // listen for tag selections
  const tag_cbs = archive_root.querySelector('.tag-cbs');
  if (tag_cbs) {
    tag_cbs.addEventListener('click', function() {
      update_active_tiles();
    });
  }

  // listen for category and tag accordion clicks
  archive_root.querySelectorAll('.filter-group').forEach(function(filter_group) {
    filter_group.addEventListener('click', function(e) {
      if (e.target.closest('.selector-title')) {
        filter_group.classList.toggle('expanded');
      }
    });
  });

  // listen for search box input
  if (search_button) {
    search_button.addEventListener('click', function() {
      // reset category selection
      archive_root.querySelectorAll('.category-buttons button').forEach(function(button) {
        button.classList.remove('active');
        button.classList.remove('sub-active');
      });
      const select_all = archive_root.querySelector('.category-buttons button#select-all');
      if (select_all) select_all.classList.add('active');
      set_category_state('all');

      const search_term = search_input ? search_input.value : '';
      const params = new URLSearchParams({
        action: 'search_media_kits',
        search_term: search_term,
        nonce: miradry_settings.nonce,
      });

      fetch(`${miradry_settings.ajax_url}?${params.toString()}`)
        .then((response) => response.json())
        .then((response) => update_active_tiles(response));
    });
  }

  if (search_input) {
    search_input.addEventListener('keypress', function(e) {
      if (e.which == 13 || e.keyCode == 13) {
        search_button.click();
      }
    });

    search_input.addEventListener('focus', function() {
      clear_search_box();
    });
  }

  function show_children(cat_id) {

    const button = archive_root.querySelector('.category-buttons #' + cat_id);

    // first, hide any visible children if this isn't a subcategory click
    if (!button || !button.classList.contains('subcategory-button')) {
      archive_root.querySelectorAll('.category-buttons .subcategory-buttons').forEach(function(el) {
        el.classList.remove('visible');
      });

    // but if this is a subcategory, make sure the parent is selected and the children are visible;
    // this is necessary when subcategories are loaded via query parameter
    } else {

      const parent_id = get_parent_cat_id(cat_id);
      const parent_group = button.closest('.subcategory-buttons');
      if (parent_group) parent_group.classList.add('visible');
      const parent_button = archive_root.querySelector('.category-buttons #' + parent_id);
      if (parent_button) parent_button.classList.add('active');

    }

    // next, if this is a parent category, show children
    const parent_class = cat_id.replace('select-', 'parent-');
    const children_group = archive_root.querySelector('.category-buttons .subcategory-buttons.' + parent_class);
    if (children_group) {
      children_group.classList.add('visible');
    }

  }

  function get_parent_cat_id(cat_id) {
    const button = archive_root.querySelector('.category-buttons #' + cat_id);
    const subcategory_buttons = button.closest('.subcategory-buttons');
    const parent_class = Array.from(subcategory_buttons.classList).find((cls) => cls.startsWith('parent-'));
    return 'select-' + parent_class.substring(7);
  }

  /**
   * @param {string} cat_id
   */
  function select_category(cat_id) {

    let button = archive_root.querySelector('.category-buttons button#' + cat_id);
    if (!button) {
      cat_id = 'select-all';
      button = archive_root.querySelector('.category-buttons button#' + cat_id);
    }

    // is this a subcategory or a parent category?
    const subcat = button.classList.contains('subcategory-button');

    archive_root.querySelectorAll('.category-buttons .subcategory-button').forEach(function(el) {
      el.classList.remove('sub-active');
    });

    if (!subcat) {
      archive_root.querySelectorAll('.category-buttons button').forEach(function(el) {
        el.classList.remove('active');
      });
      button.classList.add('active');
    } else {

      const parent_id = get_parent_cat_id(cat_id);
      archive_root.querySelectorAll('.category-buttons button').forEach(function(el) {
        if (el.id !== parent_id) el.classList.remove('active');
      });
      button.classList.add('sub-active');
    }

    update_active_tiles();
    clear_search_box();
    const cat_slug = cat_id.replace('select-', '');
    set_category_state(cat_slug);
  }

  function clear_search_box() {
    if (search_input) search_input.value = '';
    update_active_tiles();
  }

  /**
   * @param {string} cat_id
   */
  function set_category_state(cat_id) {
    const current_url = window.location.href;
    let new_url = current_url;
    if (current_url.includes('?')) {
      new_url = current_url.replace(/(\?cat=)[^&]+/, '$1' + cat_id);
    } else {
      new_url = current_url + '?cat=' + cat_id;
    }
    window.history.replaceState({}, '', new_url);
  }

  function get_selected_tags() {
    const tags = [];
    archive_root.querySelectorAll('.tag-selectors .tag-cbs .input-group').forEach(function(group) {
      const input = group.querySelector('input');
      if (input && input.checked) {
        tags.push(input.id.replace('select-', ''));
      }
    });
    return tags;
  }

  function get_selected_category() {

    const active_button = archive_root.querySelector('.category-buttons button.active');
    const sel_parent = active_button ? active_button.id.replace('select-', '') : 'all';
    const sel_child = archive_root.querySelector('.category-buttons button.sub-active');
    if (sel_child) {
      return sel_child.id.replace('select-', '');
    }
    return sel_parent;
  }

  /**
   * Updates the active/inactive tiles based on selected category
   * or, if given, any post_ids
   *
   * @param {array} post_ids
   */
  function update_active_tiles(post_ids) {

    const no_matches_msg = archive_root.querySelector('.no-matches-msg');
    const no_search_results_msg = archive_root.querySelector('.no-search-results-msg');
    if (no_matches_msg) no_matches_msg.classList.remove('active');
    if (no_search_results_msg) no_search_results_msg.classList.remove('active');

    const selected_cat = get_selected_category();
    const selected_tags = get_selected_tags();

    let at_least_one = false;

    archive_root.querySelectorAll('.media-kits .tile').forEach(function(tile) {
      const cats = tile.dataset.cats.split('|');
      const tags = tile.dataset.tags.split('|');

      // category match
      let cat_match = false;
      if (selected_cat == 'all' || cats.indexOf(selected_cat) != -1) {
        cat_match = true;
      }

      // tag match
      let tag_match = false;
      if (selected_tags.length == 0) {
        tag_match = true;
      } else {
        let i = 0;
        while (i < tags.length) {
          if (selected_tags.indexOf(tags[i]) != -1) {
            tag_match = true;
          }
          i++;
        }
      }

      // post id match
      let post_id_match = false;
      if (post_ids) {
        // don't count category or tag matches
        // searches should search all assets, not by category
        tag_match = false;
        cat_match = false;
        if (post_ids.includes(tile.dataset.postId)) {
          post_id_match = true;
        }
      }

      if ((cat_match && tag_match) || post_id_match) {
        tile.classList.remove('inactive');
        at_least_one = true;
      } else {
        tile.classList.add('inactive');
      }
    });

    if (!at_least_one && post_ids) {
      if (no_search_results_msg) no_search_results_msg.classList.add('active');
    } else if (!at_least_one) {
      if (no_matches_msg) no_matches_msg.classList.add('active');
    }
  }

};
